// References redux types
import { resourceTypesGenerator } from '../../utils';

export default resourceTypesGenerator('securityQuestions');
